<!--*
 * Main component of the application
 *
 * @author   pablo.barco
 * @date     2020-06-29
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->

<template>
  <div>
    <Notifications />
    <router-view v-if="languageLoaded"></router-view>
  </div>
</template>

<script>
import Notifications from '@/components/Notifications';

export default {
  'name': 'App',
  components: { Notifications },
  metaInfo: {
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1, maximum-scale-1, user-scalable=0'
      }
    ]
  },
  'computed': {
    languageLoaded() {
      return this.$store.state.loadedLanguage
    }
  }
}
</script>

<style scoped>
</style>
